// 语言偏好 key（仅用于未登录状态，如登录页）
export const LANGUAGE_STORAGE_KEY = 'swiftx_language';

/**
 * 获取存储的语言偏好（仅用于未登录状态）
 * 登录后应直接使用数据库中的 userInfo.account.language
 */
export const getStoredLanguage = (): string | null => {
  try {
    return localStorage.getItem(LANGUAGE_STORAGE_KEY);
  } catch {
    return null;
  }
};

/**
 * 设置存储的语言偏好（仅用于未登录状态）
 * 登录后应直接更新数据库，不需要 Local Storage
 */
export const setStoredLanguage = (language: string): void => {
  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  } catch {
    // ignore write errors (e.g. private mode)
  }
};

/**
 * 清除存储的语言偏好
 */
export const clearStoredLanguage = (): void => {
  try {
    localStorage.removeItem(LANGUAGE_STORAGE_KEY);
  } catch {
    // ignore
  }
};

